(() => {
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-mw-open-chat]');
    if (!link) return;
    event.preventDefault();
    link.setAttribute('aria-busy', 'true');
    try {
      if (!window.GorgiasChat && !document.getElementById('gorgias-chat-widget-install-v3')) {
        const script = document.createElement('script');
        script.id = 'gorgias-chat-widget-install-v3';
        script.src = 'https://config.gorgias.chat/bundle-loader/01JY6M1K702BCMJGP75G52C99T';
        script.async = true;
        document.body.appendChild(script);
      }
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => { cleanup(); reject(new Error('Chat not ready')); }, 10000);
        const ready = () => { cleanup(); resolve(); };
        const cleanup = () => {
          clearTimeout(timer);
          window.removeEventListener('gorgias-widget-loaded', ready);
        };
        if (window.GorgiasChat) {
          Promise.resolve(window.GorgiasChat.init()).then(ready, reject);
        } else {
          window.addEventListener('gorgias-widget-loaded', ready, { once: true });
        }
      });
      window.GorgiasChat.open();
    } catch {
      // Gorgias' supported URL fallback keeps support in the browser.
      window.location.assign(document.documentElement.lang.startsWith('it') ? '/it/pages/contact' : '/pages/contact');
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();
